/**
 * @desc 个人中心公用搜索
 */
import styles from './searchBar.scss';
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { Form } from 'antd';
import CompanyAutoComplete from '../../../common/companyAutoComplete/CompanyAutoComplete';
const FormItem = Form.Item;

class SearchBar extends PureComponent {
    static defaultProps = {
        searchNow: true // 立即搜索
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.searchNow && this.onSubmit();
    }

    getCompanyInfo = (selectedCompany) => {
        this.selectedCompany = selectedCompany;
    };

    resetCompanyInfo = (v) => {
        if (!this.selectedCompany || v !== this.selectedCompany.name) {
            this.selectedCompany = null;
        }
    };

    onSubmit = (e) => {
        e && e.preventDefault();
        const { validateFields } = this.props.form;
        const { onSearch } = this.props;

        validateFields({ force: true }, (err, values) => {
            if (!err) {
                // onSearch && onSearch({ ...values, companyCode: this.selectedCompany ? this.selectedCompany.code : undefined });
                onSearch && onSearch(this.selectedCompany ? { companyCode: this.selectedCompany.code } : { ...values });
            }
        });
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const { className = '' } = this.props;
        return (
            <div className={classNames(styles.searchBar, className)}>

                <Form onSubmit={this.onSubmit}>
                    <FormItem className="company-name-with-button">
                        {getFieldDecorator('companyName')(
                            <CompanyAutoComplete
                                placeholder="请输入公司名称或代码"
                                onChange={this.resetCompanyInfo} getCompanyInfo={this.getCompanyInfo}
                            />
                        )}
                        <button type="submit" className="btn btn-blue">搜索</button>
                    </FormItem>
                </Form>
            </div>
        );
    }
}

export default (Form.create({})(SearchBar));



// WEBPACK FOOTER //
// ./src/components/personal/common/searchBar/SearchBar.jsx